import Box from "@mui/material/Box";
import { isPercentage } from "src/utils/utils";
import VeeranshLogo from "../../../assets/images/Veeransh logo.png";

const Logo = ({ width = 150, height }) => {
  const logoHeight = height || (isPercentage(width) ? "auto" : width);
  return (
    <Box
      component="img"
      src={VeeranshLogo}
      alt="Veeransh Pharma Logo"
      sx={{
        width: "100%",
        // height: "50%",
      }}
    />
  );
};

export default Logo;
